<div class="analytics-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
                <h3 class="my-5">Analytics</h3>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <div class="contacts">
                <p class="m-0">Contact us:</p>
                <div>
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                    <span></span>
                    <a href="tel:+18448186243">844-818-6243</a>
                </div>
            </div>
            <div class="footer mt-2">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content">
            <div class="table-cont fixed">
                <label>Summary</label>
                <div class="main-content-block">
                    <table mat-table [dataSource]="lossRatio">
                        <ng-container matColumnDef="scac">
                            <th mat-header-cell *matHeaderCellDef>SCAC</th>
                            <td mat-cell *matCellDef="let element"> {{element.scac}} </td>
                        </ng-container>
                        <ng-container matColumnDef="afpName">
                            <th mat-header-cell *matHeaderCellDef>AFP Name</th>
                            <td mat-cell *matCellDef="let element"> {{element.afpName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="incidents">
                            <th mat-header-cell *matHeaderCellDef>Incidents</th>
                            <td mat-cell *matCellDef="let element"> {{element.incidents}} </td>
                        </ng-container>
                        <ng-container matColumnDef="netIncurred">
                            <th mat-header-cell *matHeaderCellDef>Incurred</th>
                            <td mat-cell *matCellDef="let element"> {{element.netIncurred | fixedCurrency}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedLossRatioColumns"></tr>
                        <tr mat-row class="table-row" *matRowDef="let row; columns: displayedLossRatioColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell noData text-center" colspan="10">No data</td>
                        </tr>
                    </table>

                    <div class="value-date" *ngIf="valueDate">
                        <strong>Value Date:</strong> {{ valueDate | date: 'shortDate' }}
                    </div>
                </div>
            </div>
            
            <div class="table-cont">
                <div class="searchBar">
                    <input
                        id="search"
                        class="form-input"
                        placeholder="Search"
                        (keyup)="applyClaimsFilter()"
                        [(ngModel)]="claimsGridFilterValue"
                    />
                    <label
                        for="search"
                        class="form_label"
                    >Search
                    </label>
                </div>
                <label>Claims</label>
                <table #claimsTable="matSort" mat-table matSort [dataSource]="claims" 
                    matSortActive="dateOfLoss" matSortDirection="desc">
                    <ng-container matColumnDef="claimNumber">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Claim Number</th>
                        <td mat-cell *matCellDef="let element"> {{element.claimNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="dateOfLoss">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Date of Loss</th>
                        <td mat-cell *matCellDef="let element"> {{element.dateOfLoss | date: 'shortDate'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="reportDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Report Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.reportDate | date: 'shortDate'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="claimStatus">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Claim Status</th>
                        <td mat-cell *matCellDef="let element"> {{element.claimStatus}} </td>
                    </ng-container>
                    <ng-container matColumnDef="netIncurred">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Incurred</th>
                        <td mat-cell *matCellDef="let element"> {{element.netIncurred | fixedCurrency}} </td>
                    </ng-container>
                    <ng-container matColumnDef="coverage">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Coverage</th>
                        <td mat-cell *matCellDef="let element"> {{element.coverage}} </td>
                    </ng-container>
                    <ng-container matColumnDef="amazonId">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Amazon ID</th>
                        <td mat-cell *matCellDef="let element"> {{element.amazonId}} </td>
                    </ng-container>
                    <ng-container matColumnDef="lossDescription">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Loss Description</th>
                        <td mat-cell *matCellDef="let element"> {{element.lossDescription}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedClaimsColumns"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: displayedClaimsColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell noData text-center" colspan="10">No data matching the filter <b>"{{claimsGridFilterValue}}"</b></td>
                    </tr>
                </table>
            </div>
            <div class="actions pt-3">
                <button class="primary-button"
                        [routerLink]="user?.status === 'active' ? ['/coverage'] : ['/verification']"
                        [queryParams]="user?.status === 'active' ? { qnum: qnum, qsuffix: qsuffix } : null">
                    Go back
                </button>
            </div>
        </div>
    </div>
</div>
